import { useState } from "react";
import { Mail, X, Send } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function EmailVerificationBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Email de vérification renvoyé !");
    } catch (e) {
      toast.error("Erreur, veuillez réessayer plus tard");
    } finally { setSending(false); }
  };

  return (
    <div className="bg-accent/15 border-b border-accent/30" data-testid="verify-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-3 text-sm">
        <div className="flex items-center gap-2">
          <Mail className="w-4 h-4 text-accent" />
          <span className="text-foreground">
            Vérifiez votre adresse email <strong>{user.email}</strong> pour activer toutes les fonctionnalités.
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={resend} disabled={sending} className="text-xs font-medium px-3 py-1.5 rounded-full bg-accent text-white hover:bg-[#dc7a26]" data-testid="resend-verification">
            {sending ? "…" : "Renvoyer"} <Send className="w-3 h-3 inline" />
          </button>
          <button onClick={() => setDismissed(true)} className="p-1 hover:bg-accent/20 rounded-full" aria-label="Fermer">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
